import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';

import { mobileOnly } from '../ConstantsStyles';

export const StyledText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '16px',
    [`@media ${mobileOnly}`]: {
      fontSize: '14px',
    },
    alignItems: 'center',
    display: 'flex',
    paddingRight: '4px',
    fontWeight: '500',
  },
});

// Abyss v2's Popover only applies css keyed on the exact (unprefixed) sub-element
// name, e.g. 'abyss-popover-root', via useAbyssProps - it no longer merges a single
// nested selector object (e.g. '&.abyss-popover-root { ... }') onto one root node.
export const compareSharePopoverStyles = {
  'abyss-popover-root': {
    backgroundColor: '#4B4D4F !important',
    width: '300px',
    borderWidth: '0px',
    marginLeft: '5px',
    borderRadius: '8px',
    '& svg': {
      fill: '#4B4D4F',
    },
  },
  'abyss-popover-close-button': {
    '& span': {
      backgroundColor: '#4B4D4F',
      color: '#FFFFFF',
      '&:hover, &:focus': {
        backgroundColor: '#4B4D4F !important', // Keep hover background black
      },
    },
    '&:hover': {
      backgroundColor: 'transparent !important', // Transparent background on hover
    },
  },
  'abyss-popover-close-icon': {
    // PopoverCloseIcon's static style sets icon color with !important, so match it here
    color: '#FFFFFF !important',
    '&:hover, &:active': {
      color: '#FFFFFF !important',
    },
  },
  'abyss-popover-arrow': {
    '& polygon': {
      fill: '#4B4D4F !important',
    },
    '& path': {
      stroke: '#4B4D4F !important',
    },
  },
  'abyss-popover-content-container': {
    color: '#FFFFFF',
    fontSize: '14px',
    fontFamily: '$primary',
    fontWeight: '400px',
  },
  'abyss-popover-title': {
    // PopoverTitle's static style sets color with !important, so match it here
    color: '#FFFFFF !important',
    fontSize: '18px',
    fontFamily: '$primary',
    fontWeight: '500px',
  },
};

// Since Abyss v2 keys its Popover css objects by exact sub-element name, spreading
// multiple style objects that both target e.g. 'abyss-popover-content-container'
// makes the last one clobber the others - merge per-key instead of shallow-spreading.
export const mergePopoverAbyssStyles = (
  ...styleObjects: Array<Record<string, any>>
) => {
  const merged: Record<string, any> = {};
  styleObjects.forEach((styles) => {
    Object.entries(styles).forEach(([key, value]) => {
      merged[key] =
        merged[key] && typeof value === 'object'
          ? { ...merged[key], ...value }
          : value;
    });
  });
  return merged;
};

export const coachmarkPopoverStyles = {
  'abyss-popover-content-container': {
    '& .abyss-button-root': {
      color: '#4B4D4F',
      backgroundColor: '#FFFFFF',
      border: '1px solid #4B4D4F',
    },
  },
  'abyss-popover-close-button': {
    boxShadow: 'none !important',
    '&:focus-visible': {
      border: '1px solid #FFFFFF',
    },
  },
  'abyss-popover-close-icon': {
    // PopoverCloseIcon's static style sets icon color with !important, so match it here
    color: '#FFFFFF !important',
    borderRadius: '25px',
    '&:hover, &:active': {
      color: '#FFFFFF !important',
    },
    '&:focus-visible': {
      boxShadow: 'none',
    },
  },
};
